function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.902 10.183c-.094-.094-.01-1.91-.142-1.91-.133 0-.666-2.053-.76-1.96L7 8c-.094.094 1 .868 1 1 0 .133-1.094.406-1 .5l-.525.043c.349-.194.63.402 1.025.457.395.055-.282.218 0 .5.282.282-.314.605-.259 1 .055.395-.026.652-.22 1L7 13c.046.046-.06.475 0 .5-.066 0 .06.025 0 0 .066 0-.56.525-.5.5.06-.025-.546.046-.5 0V6l7.606 1.02c.094-.093-.606.613-.606.48 0-.132-.906.594-1 .5l-.104-.199c-.349.195.208-.018-.188-.073-.395-.055-.426.554-.708.272-.282-.282-.945.395-1 0-.055-.395-.695-.152-.5-.5l-.598 2.683zm-.629-8.497a1.5 1.5 0 012.121 0l.781.782c.34.34.28.818.108 1.106a.833.833 0 001.142 1.142c.289-.17.767-.232 1.107.108l.781.782a1.502 1.502 0 010 2.122l-6.585 6.585a1.502 1.502 0 01-2.122 0l-.78-.78c-.34-.34-.28-.82-.109-1.107a.833.833 0 00-1.142-1.142c-.289.171-.767.232-1.107-.109l-.782-.781a1.499 1.499 0 010-2.122l6.587-6.586z",
  fill: "#8F90A6"
});

function SvgTicketTypeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTicketTypeFilled;